/* 07EVEN relaunch (Aun, 2026-10-23): size pickers, gallery dots, sheets, bag, sticky bar, add-on second set. */
(function () {
  if (window.__ae) return; window.__ae = 1;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); };

  /* sheets */
  function openSheet(id) { var s = document.getElementById(id); if (!s) return; s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-open'); }); document.documentElement.classList.add('ae-lock'); }
  function closeSheet(s) { s.classList.remove('is-open'); document.documentElement.classList.remove('ae-lock'); setTimeout(function () { s.hidden = true; }, 220); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ae-open]'); if (o) { e.preventDefault(); openSheet(o.getAttribute('data-ae-open')); return; }
    var c = e.target.closest('[data-ae-close]'); if (c) { closeSheet(c.closest('.ae-sheet')); return; }
    if (e.target.classList && e.target.classList.contains('ae-sheet')) closeSheet(e.target);
    var t = e.target.closest('[data-ae-tabs] [data-tab]');
    if (t) { var w = t.closest('[data-ae-tabs]'); $$('[data-tab]', w).forEach(function (b) { b.classList.toggle('is-on', b === t); });
      $$('[data-panel]', w).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === t.getAttribute('data-tab')); }); }
  });

  /* header bag button: opens the ae bag with the live cart on every page */
  document.addEventListener('click', function (e) {
    var hb = e.target.closest('[data-ae-bagbtn]'); if (!hb) return;
    e.preventDefault();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(showBag);
  });
  function setCount(n) { $$('[data-ae-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; }); }
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});

  /* cart page: qty / remove */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ae-qty]'); if (!q) return;
    q.disabled = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-ae-qty'), quantity: Math.max(0, +q.getAttribute('data-to')) }) })
      .then(function () { location.reload(); }).catch(function () { q.disabled = false; });
  });

  /* gallery dots */
  $$('[data-ae-slides]').forEach(function (sl) {
    var dots = sl.parentNode.querySelector('[data-ae-dots]'); var n = sl.children.length; if (!dots || n < 2) return;
    for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1)); (function (k) { b.onclick = function () { sl.scrollTo({ left: sl.children[k].offsetLeft, behavior: 'smooth' }); }; })(i); dots.appendChild(b); }
    var mark = function () { var k = Math.round(sl.scrollLeft / sl.clientWidth); $$('button', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); };
    sl.addEventListener('scroll', function () { clearTimeout(sl._t); sl._t = setTimeout(mark, 60); }); mark();
  });

  /* bag */
  function bubble(count) { setCount(count); }
  function showBag(cart) {
    var lines = $('[data-ae-bag-lines]'); if (!lines) return;
    var ok = $('[data-ae-bag-ok]'), go = $('[data-ae-bag-go]'), empty = !cart.item_count, opened = document.getElementById('ae-bag').classList.contains('is-open');
    if (ok) ok.textContent = empty ? 'Your bag is empty' : (window.__aeJustAdded ? '\u2713 Added to your bag' : 'Your bag');
    if (go) go.hidden = empty;
    var cmp = {}; try { cmp = JSON.parse($('[data-ae-compare]').textContent); } catch (e) {}
    var was = 0;
    lines.innerHTML = cart.items.map(function (it) {
      var full = Math.max((cmp[it.variant_id] || 0) * it.quantity, it.original_line_price); was += full;
      return '<div class="ae-bag__line"><img src="' + (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '') + '" alt="" width="64" height="64"><div><b>' + it.product_title + '</b><span>' +
        (it.variant_title || '') + ' · qty ' + it.quantity + '</span></div><b>' + (full > it.final_line_price ? '<s>' + money(full) + '</s>' : '') + money(it.final_line_price) + '</b></div>';
    }).join('');
    $('[data-ae-bag-total]').innerHTML = (was > cart.total_price ? '<s>' + money(was) + '</s>' : '') + money(cart.total_price);
    var save = $('[data-ae-bag-save]'), saved = was - cart.total_price;
    if (save) { save.hidden = saved <= 0; save.textContent = "You're saving " + money(saved) + ' + free shipping'; }
    var sets = cart.items.filter(function (i) { return /-set$/.test(i.handle); }).reduce(function (a, i) { return a + i.quantity; }, 0);
    var note = $('[data-ae-bag-note]');
    note.textContent = sets === 1 ? 'Add one more set and the pair is $175 (you save $25).' : '';
    bubble(cart.item_count); openSheet('ae-bag');
  }
  function add(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) { window.__aeJustAdded = true; showBag(c); window.__aeJustAdded = false; });
  }

  /* product page */
  var root = $('[data-ae-pdp]'); if (!root) return;
  var data = JSON.parse($('[data-ae-product]').textContent);
  var form = $('[data-ae-form]', root), vid = $('[data-ae-vid]', root), addBtn = $('[data-ae-add]', root), label = $('[data-ae-add-label]', root);
  var picks = $$('[data-ae-opt]', root).map(function (fs) { var on = $('.ae-pill.is-on', fs); return on ? on.getAttribute('data-v') : null; });
  function current() { return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === picks[i]; }); })[0]; }
  function sync() {
    var v = current();
    $$('[data-ae-opt]', root).forEach(function (fs, i) {
      $$('.ae-pill', fs).forEach(function (p) {
        var val = p.getAttribute('data-v'); p.classList.toggle('is-on', val === picks[i]);
        var ok = data.variants.some(function (x) { return x.available && x.options[i] === val && x.options.every(function (o, j) { return j === i || o === picks[j]; }); });
        p.classList.toggle('is-out', !ok);
      });
    });
    if (v) { vid.value = v.id; addBtn.disabled = !v.available; label.textContent = v.available ? 'ADD TO BAG · ' + money(v.price) : 'SOLD OUT IN THIS SIZE'; $('[data-ae-price]', root).textContent = money(v.price);
      var sp = $('[data-ae-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var ss = $('[data-ae-sticky-sizes]'); if (ss) ss.textContent = data.options.length > 1 ? 'Jacket ' + picks[0] + ' · Sweats ' + picks[1] : 'Size ' + picks[0];
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
    else { addBtn.disabled = true; label.textContent = 'PICK YOUR SIZES'; }
  }
  root.addEventListener('click', function (e) {
    var p = e.target.closest('.ae-pill'); if (!p) return;
    var i = +p.closest('[data-ae-opt]').getAttribute('data-ae-opt'); picks[i] = p.getAttribute('data-v'); sync();
  });
  var busy = false;
  function doAdd() {
    if (busy || addBtn.disabled) return; busy = true; var old = label.textContent; label.textContent = 'ADDING…';
    add([{ id: +vid.value, quantity: 1 }]).catch(function (err) { alert(err.message); }).then(function () { busy = false; label.textContent = old; });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(); });
  var sAdd = $('[data-ae-sticky-add]'); if (sAdd) sAdd.addEventListener('click', doAdd);

  /* second set in the same sizes */
  $$('[data-ae-second]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      var titles = JSON.parse(b.getAttribute('data-variants')), ids = JSON.parse(b.getAttribute('data-ids')), av = JSON.parse(b.getAttribute('data-avail'));
      var want = picks.join(' / '), k = titles.indexOf(want);
      if (k < 0 || !av[k]) { alert('That colour is sold out in ' + want + '. Pick another colour.'); return; }
      var v = current(); if (!v || !v.available) return;
      b.classList.add('is-busy');
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var have = c.items.some(function (it) { return it.variant_id === v.id; });
        return add(have ? [{ id: ids[k], quantity: 1 }] : [{ id: v.id, quantity: 1 }, { id: ids[k], quantity: 1 }]);
      }).catch(function (err) { alert(err.message); }).then(function () { b.classList.remove('is-busy'); });
    });
  });

  /* sticky bar once the main button scrolls away */
  var sticky = $('[data-ae-sticky]');
  var foot = $('.ae-ft');
  if (sticky && foot && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) sticky.setAttribute('data-ae-off', ''); else sticky.removeAttribute('data-ae-off'); }).observe(foot);
  }
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var below = en[0].boundingClientRect.top < 0; sticky.hidden = en[0].isIntersecting || !below; }).observe(addBtn);
  }
  sync();
})();
